export const staticAssociatePrograms = [
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "14",
        Heading: "Bachelor of Arts (BA)",
        ProgramType: "UG_Program",
        SpecializationText: "BACHELOR OF ARTS",
        PROGRAM_ID: "244",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "41",
        Heading: "Bachelors of Arts (General) Hindi Medium",
        ProgramType: "UG_Program",
        SpecializationText: "Bachelor of Arts in Hindi Medium",
        PROGRAM_ID: "244",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "39",
        Heading: "Bachelors of Arts (General) in Kannada Medium",
        ProgramType: "UG_Program",
        SpecializationText: "Bachelor of Arts in (Kannada)",
        PROGRAM_ID: "244",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "37",
        Heading: "Bachelor of Arts (General) in Malayalam Medium",
        ProgramType: "UG_Program",
        SpecializationText: "Bachelor of Arts (General) in Malayalam Medium",
        PROGRAM_ID: "244",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "38",
        Heading: "Bachelor of Arts (General) in Tamil Medium",
        ProgramType: "UG_Program",
        SpecializationText: "Bachelor of Arts in (Tamil)",
        PROGRAM_ID: "244",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "40",
        Heading: "Bachelors of Arts (General) in Telugu Medium",
        ProgramType: "UG_Program",
        SpecializationText: "Bachelor of Arts in (Telugu)",
        PROGRAM_ID: "244",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "15",
        Heading: "Bachelor of Arts (BA) Journalism and Mass Communication",
        ProgramType: "UG_Program",
        SpecializationText: "Bachelor of Arts (Journalism and Mass Communication)",
        PROGRAM_ID: "242",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "3",
        Heading: "Bachelor of Business Administration (BBA)",
        ProgramType: "UG_Program",
        SpecializationText: null,
        PROGRAM_ID: "240",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "13",
        Heading: "Bachelor of Commerce (B.Com)",
        ProgramType: "UG_Program",
        SpecializationText: "BACHELOR OF COMMERCE",
        PROGRAM_ID: "243",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "58",
        Heading: "Bachelor of Commerce (B.Com) Honours",
        ProgramType: "UG_Program",
        SpecializationText: "B.Com Honours",
        PROGRAM_ID: "612",
        Custom10PgType: "HARPU-Jaipur",
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "11",
        Heading: "Bachelor of Computer Applications (BCA)",
        ProgramType: "UG_Program",
        SpecializationText: null,
        PROGRAM_ID: "241",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "45",
        Heading: "BBA with specialization in Data Analytics",
        ProgramType: "UG_Program",
        SpecializationText: "BBA Specialization in Data Analytics",
        PROGRAM_ID: "240",
        Custom10PgType: "HARPU-HCL",
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "47",
        Heading:
          "Bachelor of Computer Applications (BCA) with Specialization in Software Engineering",
        ProgramType: "UG_Program",
        SpecializationText: "Software Engineering",
        PROGRAM_ID: "241",
        Custom10PgType: "HARPU-HCL",
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "16",
        Heading: "Master of Arts (MA) in Journalism and Mass Communication",
        ProgramType: "PG_Program",
        SpecializationText: "MASTER OF ARTS (JOURNALISM AND MASS COMMUNICATION)",
        PROGRAM_ID: "246",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "17",
        Heading: "Master of Arts (MA) in Public Policy & Governance",
        ProgramType: "PG_Program",
        SpecializationText: "MASTER OF ARTS (PUBLIC POLICY & GOVERNANCE)",
        PROGRAM_ID: "608",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "10",
        Heading: "Master of Business Administration",
        ProgramType: "PG_Program",
        SpecializationText: null,
        PROGRAM_ID: "440",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "18",
        Heading: "Master of Commerce (M.Com) in Financial Management",
        ProgramType: "PG_Program",
        SpecializationText: "MASTER OF COMMERCE (FINANCIAL MANAGEMENT)",
        PROGRAM_ID: "245",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "12",
        Heading: "Master of Computer Applications (MCA)",
        ProgramType: "PG_Program",
        SpecializationText: "MASTER OF COMPUTER APPLICATIONS",
        PROGRAM_ID: "515",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "56",
        Heading: "Master of Science (M.Sc) Data Science",
        ProgramType: "PG_Program",
        SpecializationText: "MSc Data Science",
        PROGRAM_ID: "613",
        Custom10PgType: "HARPU-Jaipur",
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "48",
        Heading: "Master of Computer Applications (MCA) with Specialization in Cyber Security",
        ProgramType: "PG_Program",
        SpecializationText: "Specialisation in Cyber Security",
        PROGRAM_ID: "515",
        Custom10PgType: "HARPU-HCL",
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "106",
        Heading:
          "Bachelor of Business Administration (BBA) with Professional Certificate in Business Analytics",
        ProgramType: "UG_Program",
        SpecializationText: "BBA with a Professional Certificate in Business Analytics",
        PROGRAM_ID: "240",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "107",
        Heading:
          "Bachelor of Computer Applications (BCA) with Professional Certificate in Applied Data Engineering",
        ProgramType: "UG_Program",
        SpecializationText: "BCA Applied Data Engineering",
        PROGRAM_ID: "241",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "104",
        Heading:
          "Bachelor of Business Administration (BBA) with Specialization in Travel and Tourism Management",
        ProgramType: "UG_Program",
        SpecializationText: "Travel and Tourism Management",
        PROGRAM_ID: "240",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "91",
        Heading: "BBA + MBA Degree Program",
        ProgramType: "UG_Program",
        SpecializationText: "BBA + MBA Degree Program",
        PROGRAM_ID: "618",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "92",
        Heading: "B.Com + MBA Degree Program",
        ProgramType: "UG_Program",
        SpecializationText: "B.Com + MBA Degree Program",
        PROGRAM_ID: "620",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "86",
        Heading: "Master of Business Administration (MBA) with Dual Specialization",
        ProgramType: "PG_Program",
        SpecializationText: "MBA With Dual Specialization",
        PROGRAM_ID: "440",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "103",
        Heading: "Bachelor of Computer Applications (BCA) with Specialization in Data Engineering",
        ProgramType: "UG_Program",
        SpecializationText: "Data Engineering",
        PROGRAM_ID: "241",
        Custom10PgType: "HARPU-HCL",
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "102",
        Heading: "Bachelor of Computer Applications (BCA) with Specialization in Data Science",
        ProgramType: "UG_Program",
        SpecializationText: "BCA with specialization in Data Science",
        PROGRAM_ID: "241",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "93",
        Heading: "BCA + MCA Degree Program",
        ProgramType: "UG_Program",
        SpecializationText: "BCA + MCA Degree Program",
        PROGRAM_ID: "619",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "49",
        Heading:
          "Master of Computer Applications (MCA) with Specialization in Software Engineering ",
        ProgramType: "PG_Program",
        SpecializationText: "Software Engineering",
        PROGRAM_ID: "515",
        Custom10PgType: "HARPU-HCL",
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "89",
        Heading: "UG + PG Degree Program",
        ProgramType: "UG_Program",
        SpecializationText: "UG + PG Degree Program",
        PROGRAM_ID: "440",
        Custom10PgType: null,
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "28",
        Heading:
          "Master of Computer Applications (MCA) with Specialization in Blockchain Technology and Management",
        PROGRAM_ID: "515",
        SpecializationText: "BLOCKCHAIN TECHNOLOGY AND MANAGEMENT",
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "112",
        Heading: "Master of Business Administration (MBA) in Hospital and Healthcare Management",
        PROGRAM_ID: "440",
        SpecializationText: "Hospital & Healthcare Management(Medvarsity)",
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "35",
        Heading:
          "Bachelor of Commerce (B.Com) with Specialization in International Finance & Accounting",
        PROGRAM_ID: "243",
        SpecializationText: "International Finance & Accounting",
        ProgramType: "UG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "108",
        Heading: "BCA with specialization in Financial Technology and AI",
        PROGRAM_ID: "241",
        SpecializationText: "Financial Technology and AI (PayTM)",
        ProgramType: "UG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "109",
        Heading: "MCA with specialization in Financial Technology and AI",
        PROGRAM_ID: "515",
        SpecializationText: "Financial Technology and AI (PayTM)",
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "23",
        Heading:
          "Master of Business Administration (MBA) with Specialization in Human Resource Analytics",
        PROGRAM_ID: "440",
        SpecializationText: "HUMAN RESOURCES ANALYTICS",
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "43",
        Heading:
          "Master of Business Administration (MBA) with Specialization in Digital Marketing Management",
        PROGRAM_ID: "440",
        SpecializationText: "Digital Marketing",
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "32",
        Heading:
          "Master of Business Administration (MBA) with Specialization in Digital Entrepreneurship",
        PROGRAM_ID: "440",
        SpecializationText: "DIGITAL ENTREPRENEURSHIP",
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "27",
        Heading:
          "Master of Business Administration (MBA) with Specialization in Business Analytics",
        PROGRAM_ID: "440",
        SpecializationText: "Business Analytics",
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: { __typename: "Specialization", BasicDetails: null },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "87",
        Heading: "Master of Business Administration (MBA) in General Management",
        PROGRAM_ID: "440",
        SpecializationText: "MBA in General Management",
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "26",
        Heading: "Master of Business Administration (MBA) with Specialization in Data Science",
        PROGRAM_ID: "440",
        SpecializationText: "DATA SCIENCE",
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "29",
        Heading:
          "Master of Computer Applications (MCA) with Specialization in Machine Learning and Artificial Intelligence",
        PROGRAM_ID: "515",
        SpecializationText: "ML & AI",
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "30",
        Heading:
          "Master of Computer Applications (MCA) with Specialization in Machine Learning & Artificial Intelligence",
        PROGRAM_ID: "515",
        SpecializationText: "Machine Learning & Artificial Intelligence",
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "33",
        Heading: "Master of Commerce (M.Com) with Specialization in Financial Technology",
        PROGRAM_ID: "245",
        SpecializationText: null,
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "31",
        Heading:
          "Master of Business Administration (MBA) with Specialization in International Finance",
        PROGRAM_ID: "440",
        SpecializationText: "International Finance",
        ProgramType: "PG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "42",
        Heading:
          "Bachelor of Computer Applications (BCA) with Specialization in Cloud and Security",
        PROGRAM_ID: "241",
        SpecializationText: "Cloud and Security",
        ProgramType: "UG_Program",
      },
    },
  },
  {
    __typename: "SpecializationEntity",
    attributes: {
      __typename: "Specialization",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "34",
        Heading: "Bachelor of Computer Applications (BCA) with Specialization in Data Analytics",
        PROGRAM_ID: "241",
        SpecializationText: "Data Analytics",
        ProgramType: "UG_Program",
      },
    },
  },
];
